import React from "react";
import { Card, Row, Col } from "antd";
import watchIcon from "../../assests/images/watchIcon.svg";
import "./DashboardCard.scss";

function DashboardDayTotal({ dayTotal, freightCharges, cashCharger }) {
  return (
    <Row>
      <Card
        className="cardFlex"
        title={
          <div>
            {" "}
            <img
              width="24px"
              height="24px"
              className="cardFlex-icon"
              src={watchIcon}
            />
            <span className="totalDay"> {dayTotal}</span>
          </div>
        }
        style={{
          width: "100%",
          borderRadius: "10px",
          boxShadow: "0px 0px 1px 1px rgba(107, 107, 107, 0.06)"
        }}
      >
        <Row className="dayTotalWrapper" style={{padding: "2.5px"}}>
          <Col className="dayTotalInnerBox" span={12} style={{borderRight:"1px solid #EBF1FA"}}>
            <span className="dayTotalInnerBoxRuppesText"> ₹1000</span>

            <p className="dayTotalInnerBoxText">{cashCharger}</p>
          </Col>
          <Col className="dayTotalInnerBox" span={12}>
            <span className="dayTotalInnerBoxRuppesText"> ₹556</span>
            <p className="dayTotalInnerBoxText">{freightCharges}</p>
          </Col>
        </Row>
      </Card>
    </Row>
  );
}

export default DashboardDayTotal;
